import { render } from "./OnlyPaymentForm.vue?vue&type=template&id=12bfde21&scoped=true"
import script from "./OnlyPaymentForm.vue?vue&type=script&lang=js"
export * from "./OnlyPaymentForm.vue?vue&type=script&lang=js"

import "./OnlyPaymentForm.vue?vue&type=style&index=0&id=12bfde21&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12bfde21"]])

export default __exports__